import { IFilterProvider } from "./interfaces/filter-providers/IFilterProvider";

export class Deployment {

	public static isLatestVersion(filterProvider: IFilterProvider): boolean {
		return filterProvider.getFilterKeySelection !== undefined;
	}
}
